import { useState, useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import Footer from '../components/Footer'
import { useAuth } from '../contexts/AuthContext'
import { supabase } from '../config/supabase'
import { useNavigate } from 'react-router-dom'

const Tutorial = () => {
  const { user } = useAuth()
  const navigate = useNavigate()
  const [profile, setProfile] = useState(null)
  const [selectedSection, setSelectedSection] = useState('beginner')

  const tutorials = {
    beginner: [
      {
        title: 'EP.1 เตรียมพร้อมสมัคร Account ต่างๆ',
        videoUrl: 'https://www.youtube.com/embed/QGXQfpmv_Zc',
        category: 'beginner'
      },
      {
        title: 'EP.2 เลือก plan Midjourney และทำการเชื่อม Discord',
        videoUrl: 'https://www.youtube.com/embed/8FnKBEyAais',
        category: 'beginner'
      },
      {
        title: 'EP.3 การสร้างเซิฟ Discord และติดตั้ง AutoJourney',
        videoUrl: 'https://www.youtube.com/embed/oRKFFYJdAbI',
        category: 'beginner'
      },
      {
        title: 'EP.4 การสมัครและเติมเงิน OpenAI API(ไม่ต้องทำ)',
        videoUrl: 'https://www.youtube.com/embed/x-yJim3Ee_o',
        category: 'beginner'
      },
      {
        title: 'EP.4-2 การสร้าง Gemini API Key',
        videoUrl: 'https://www.youtube.com/embed/XJNROvjXgaE',
        category: 'beginner'
      },
      {
        title: 'EP.5 การสร้าง Prompt ด้วย GPT และ Unlocked VIP',
        videoUrl: 'https://www.youtube.com/embed/umlci09hexM',
        category: 'beginner'
      },
      {
        title: 'EP.6 คัดภาพขั้นแรกด้วย Image Checker',
        videoUrl: 'https://www.youtube.com/embed/ISQoyD70cQE',
        category: 'beginner'
      },
      {
        title: 'EP.7 การแบ่งภาพเป็นชุดด้วย Image Separator',
        videoUrl: 'https://www.youtube.com/embed/FfHbeOStwUY',
        category: 'beginner'
      },
      {
        title: 'EP.8 หลักการคัดภาพเสีย',
        videoUrl: 'https://www.youtube.com/embed/7RO8GhUzDp4',
        category: 'beginner'
      },
      {
        title: 'EP.9 การขั้นภาพเองด้วย Adobe Bridge',
        videoUrl: 'https://www.youtube.com/embed/CIiLEgxHCVg',
        category: 'beginner'
      },
      {
        title: 'EP.10 การอัพสเกลด้วย Topaz Gigapixel AI',
        videoUrl: 'https://www.youtube.com/embed/BSa-v-y0K-w',
        category: 'beginner'
      },
      {
        title: 'EP.11 การอัพเสกลด้วย Upscayl (ฟรี)',
        videoUrl: 'https://www.youtube.com/embed/Ow8JM3LT4W4',
        category: 'beginner'
      },
      {
        title: 'EP.12 การตั้ง Title Keywords ด้วย MetaMind(ไม่ต้องทำ)',
        videoUrl: 'https://www.youtube.com/embed/RLPkXcjRUwc',
        category: 'beginner'
      },
      {
        title: 'EP.12-2 การตั้ง Title Keywords ด้วย MetaMind-G',
        videoUrl: 'https://www.youtube.com/embed/qQPPZU8yaf8',
        category: 'beginner'
      },
      {
        title: 'EP.13 การ Upload และ Submit ขึ้น Adobe Stock',
        videoUrl: 'https://www.youtube.com/embed/K1yfPrbPveY',
        category: 'beginner'
      },
      {
        title: 'EP.14 การกรอกฟอร์มภาษี ก่อนถอนเงินบน Adobe',
        videoUrl: 'https://www.youtube.com/embed/R9aI6Gu4Q9c',
        category: 'beginner'
      }
    ],
    technique: [
      {
        title: 'T.7 Workflow #2 การทำงานฉบับ 3-2025',
        videoUrl: 'https://www.youtube.com/embed/3WhZUMEintE',
        category: 'technique',
        isNew: true,
        titleColor: 'text-gradient-purple'
      },  
      {
        title: 'T.6 การทำ Personalize & Moodboard',
        videoUrl: 'https://www.youtube.com/embed/1IW762AX_BA',
        category: 'technique',
        isNew: true,
        titleColor: 'text-gradient-purple'
      },  
      {
        title: 'T.5 Workflow #1 การทำงานฉบับ 3-2025',
        videoUrl: 'https://www.youtube.com/embed/3WhZUMEintE',
        category: 'technique',
        titleColor: 'text-gradient-purple'
      },
      {
        title: 'T.4 การใช้ Midjourney Moodboard',
        videoUrl: 'https://www.youtube.com/embed/4cjQlyySHm4',
        category: 'technique'
      },
      {
        title: 'T.3 เทคนิคการใช้ GPT สร้าง Prompt',
        videoUrl: 'https://www.youtube.com/embed/PoKJBHF7W2Q',
        category: 'technique'
      },
      {
        title: 'T.2 ขายภาพ AI 1 วันทำอะไรบ้าง',
        videoUrl: 'https://www.youtube.com/embed/lR0kDWP0654',
        category: 'technique'
      },
      {
        title: 'T.1 การปรับ Mindset ทำไมขายไม่ได้',
        videoUrl: 'https://www.youtube.com/embed/uxUwjo6uzjE',
        category: 'technique'
      }
    ],
    update: [
      {
        title: 'U.7 MetaMind G v1.1 เพิ่ม OpenAI',
        videoUrl: 'https://www.youtube.com/embed/1CL35xfqq14',
        category: 'update',
        isNew: true,
        titleColor: 'text-gradient-purple'
      },
      {
        title: 'U.8 MetaMind 4.1 คู่มือ',
        videoUrl: 'https://www.youtube.com/embed/ZxlJR8oNJSA',
        category: 'update'
      },
      {
        title: 'U.1 เครื่องมือทั้งหมด (3 มีนาคม 2568)',
        videoUrl: 'https://www.youtube.com/embed/Y6DuDZqn660',
        category: 'update'
      },
      {
        title: 'U.2 MeteMind 4.0',
        videoUrl: 'https://www.youtube.com/embed/X-iAOIiiFK0',
        category: 'update'
      },
      {
        title: 'U.3 Ready Prompt 2.0',
        videoUrl: 'https://www.youtube.com/embed/XtTg1Q97hm8',
        category: 'update'
      },
      {
        title: 'U.4 หมูด่าง 2.0',
        videoUrl: 'https://www.youtube.com/embed/u7z_g0bJHYk',
        category: 'update'
      },
      {
        title: 'U.5 หมูด่าง 1.0',
        videoUrl: 'https://www.youtube.com/embed/bi5QfqAoipA',
        category: 'update'
      },
      {
        title: 'U.6 Image Checker 2.6',
        videoUrl: 'https://www.youtube.com/embed/jFLC1XqlIcU',
        category: 'update'
      }
    ]
  }

  const getYoutubeUrl = (embedUrl) => {
    const videoId = embedUrl.split('/').pop();
    return `https://www.youtube.com/watch?v=${videoId}`;
  };

  const getYoutubeThumbnail = (embedUrl) => {
    const videoId = embedUrl.split('/').pop();
    return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
  };

  useEffect(() => {
    const checkAuth = async () => {
      if (!user) {
        navigate('/vip')
        return
      }

      try {
        const { data, error } = await supabase
          .from('profiles')
          .select('*')
          .eq('id', user.id)
          .single()

        if (error) {
          navigate('/vip')
          return
        }

        if (!data) {
          navigate('/vip')
          return
        }

        const allowedMemberships = ['vip', 'admin', 'lifetime']
        if (!allowedMemberships.includes(data.membership?.toLowerCase())) {
          navigate('/vip')
          return
        }

        setProfile(data)

      } catch (error) {
        navigate('/vip')
      }
    }

    checkAuth()
  }, [user, navigate])

  if (!profile) {
    return (
      <div className="min-h-screen bg-gray-900 flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-purple-500"></div>
      </div>
    )
  }

  const filteredTutorials = selectedSection === 'all'
    ? [...tutorials.beginner, ...tutorials.technique, ...tutorials.update]
    : tutorials[selectedSection] || []

  return (
    <div className="min-h-screen bg-black text-white flex flex-col">
      <Helmet>
        <title>บทเรียนและคำแนะนำ</title>
      </Helmet>
      
      <main className="flex-grow container mx-auto px-4 py-8">
        <div className="max-w-7xl mx-auto">
          {/* สารบัญ */}
          <div className="bg-gray-900/50 rounded-xl p-6 mb-8 border border-gray-800">
            <h2 className="text-2xl font-bold mb-4">สารบัญบทเรียน</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="space-y-2">
                <h3 className="text-lg font-semibold text-red-500">มือใหม่</h3>
                <ul className="list-disc list-inside text-gray-300 space-y-1">
                  {tutorials.beginner.map((tutorial, index) => (
                    <li key={index}>
                      <a 
                        href={getYoutubeUrl(tutorial.videoUrl)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hover:text-white transition-colors"
                      >
                        {tutorial.title}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="space-y-2">
                <h3 className="text-lg font-semibold text-yellow-500">เทคนิค</h3>
                <ul className="list-disc list-inside text-gray-300 space-y-1">
                  {tutorials.technique.map((tutorial, index) => (
                    <li key={index}>
                      <a 
                        href={getYoutubeUrl(tutorial.videoUrl)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`hover:text-white transition-colors ${tutorial.titleColor || ''}`}
                      >
                        {tutorial.title}
                        {tutorial.isNew && (
                          <span className="ml-2 inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gradient-to-r from-purple-500 to-pink-500 text-white">
                            ใหม่
                          </span>
                        )}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="space-y-2">
                <h3 className="text-lg font-semibold text-green-500">อัพเดทโปรแกรม</h3>
                <ul className="list-disc list-inside text-gray-300 space-y-1">
                  {tutorials.update.map((tutorial, index) => (
                    <li key={index}>
                      <a 
                        href={getYoutubeUrl(tutorial.videoUrl)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`hover:text-white transition-colors ${tutorial.titleColor || ''}`}
                      >
                        {tutorial.title}
                        {tutorial.isNew && (
                          <span className="ml-2 inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gradient-to-r from-purple-500 to-pink-500 text-white">
                            ใหม่
                          </span>
                        )}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* แถบตัวกรอง */}
          <div className="flex gap-2 mb-6">
            <button
              onClick={() => setSelectedSection('beginner')}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                selectedSection === 'beginner'
                  ? 'bg-red-500 text-white'
                  : 'bg-gray-800 text-gray-300 hover:bg-gray-700'
              }`}
            >
              มือใหม่
            </button>
            <button
              onClick={() => setSelectedSection('technique')}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                selectedSection === 'technique'
                  ? 'bg-yellow-500 text-black'
                  : 'bg-gray-800 text-gray-300 hover:bg-gray-700'
              }`}
            >
              เทคนิค
            </button>
            <button
              onClick={() => setSelectedSection('update')}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                selectedSection === 'update'
                  ? 'bg-green-500 text-black'
                  : 'bg-gray-800 text-gray-300 hover:bg-gray-700'
              }`}
            >
              อัพเดทโปรแกรม
            </button>
          </div>

          {/* บทเรียน */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {filteredTutorials.map((tutorial, index) => (
              <div 
                key={index} 
                id={`tutorial-${tutorial.category}-${index}`}
                className="bg-gray-900 rounded-lg overflow-hidden border border-gray-700"
              >
                <div className="aspect-w-16 aspect-h-9 relative group">
                  <a 
                    href={getYoutubeUrl(tutorial.videoUrl)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block w-full h-full"
                  >
                    <img 
                      src={getYoutubeThumbnail(tutorial.videoUrl)} 
                      alt={tutorial.title}
                      className="w-full h-full object-cover rounded-t-lg"
                    />
                    <div className="absolute inset-0 flex items-center justify-center opacity-80 group-hover:opacity-100 transition-opacity">
                      <svg className="w-16 h-16 text-red-600" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z" />
                      </svg>
                    </div>
                  </a>
                </div>
                <div className="p-4">
                  <h3 className={`text-lg font-semibold ${tutorial.titleColor}`}>{tutorial.title}</h3>
                  {tutorial.isNew && <span className="text-sm text-red-500">ใหม่!</span>}
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  )
}

export default Tutorial
